var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTweekLogoWithRoundedBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FEFFF9",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29010_64979)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29010_64979",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1357 13.3418H16.956C15.043 13.3418 13.4922 14.8926 13.4922 16.8056V27.175C13.4922 29.088 15.043 30.6388 16.956 30.6388H28.1357C30.0487 30.6388 31.5995 29.088 31.5995 27.175V16.8056C31.5995 14.8926 30.0487 13.3418 28.1357 13.3418Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29010_64979)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5466 19.2021V20.5971H18.3638V30.2653H16.9699V20.5971H12.7871V19.2021H16.9699H18.3638H22.5466Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5756 21.9912H14.1816V27.5679H15.5756V21.9912Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7578 21.9912H21.1528V26.174H30.821V27.5679H21.1528V31.7507H19.7578V27.5679V26.174V21.9912Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1236 28.9619H22.5469V30.3558H28.1236V28.9619Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8438 24.779V23.3851H27.0266V13.7158H28.4205V23.3851H32.6033V24.779H28.4205H27.0266H22.8438Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2084 16.4141H29.8145V21.9908H31.2084V16.4141Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6315 21.991H24.2366V17.8082H14.5684V16.4143H24.2366V12.2314H25.6315V16.4143V17.8082V21.991Z",
    fill: "#F26A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8424 13.625H17.2656V15.0189H22.8424V13.625Z",
    fill: "#F26A31"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29010_64979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8417,
    height: 19.039,
    fill: "white",
    transform: "translate(13.5781 12.2305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweekLogoWithRoundedBorder);
export default __webpack_public_path__ + "static/media/tweekLogoWithRoundedBorder.4abba0957a1e9bbc58f78e7697b078ea.svg";
export { ForwardRef as ReactComponent };